import type { Feature } from '../types/feature.types';

export const features: Feature[] = [
  {
    id: 'brand-new',
    iconBgColor: 'bg-sky-100',
    iconColor: 'text-sky-600',
    icon: (
      <svg className="w-6 h-6 text-sky-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path>
      </svg>
    ),
    title: 'BRAND-NEW Luxury Carts',
    description: 'Stretch out, bring the whole crew, ride in STYLE.',
  },
  {
    id: 'extended-range',
    iconBgColor: 'bg-green-100',
    iconColor: 'text-green-600',
    icon: (
      <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
      </svg>
    ),
    title: 'Over 20 Miles Per Charge',
    description: 'Cruise ALL DAY without worrying about plugging in.',
  },
  {
    id: 'free-cooler',
    iconBgColor: 'bg-blue-100',
    iconColor: 'text-blue-600',
    icon: (
      <svg className="w-6 h-6 text-blue-600" fill="currentColor" viewBox="0 0 512 512">
        <path d="M448,128H384V96a32,32,0,0,0-32-32H160a32,32,0,0,0-32,32v32H64A32,32,0,0,0,32,160V416a32,32,0,0,0,32,32H448a32,32,0,0,0,32-32V160A32,32,0,0,0,448,128ZM160,96H352v32H160ZM448,416H64V160H448Z"/>
        <path d="M144,224h64v64h-64zm80,0h64v64h-64zm80,0h64v64h-64zm-160,80h64v64h-64zm80,0h64v64h-64zm80,0h64v64h-64z"/>
      </svg>
    ),
    title: 'FREE Cooler with Ice',
    description: 'Snacks stay fresh, drinks stay cold, everyone stays HAPPY.',
  },
  {
    id: 'premium-sound',
    iconBgColor: 'bg-orange-100',
    iconColor: 'text-orange-600',
    icon: (
      <svg className="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"></path>
      </svg>
    ),
    title: 'Premium Sound System',
    description: 'Let the GOOD TIMES roll all the way to the beach.',
  },
  {
    id: 'touchscreen-carplay',
    iconBgColor: 'bg-purple-100',
    iconColor: 'text-purple-600',
    icon: (
      <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"></path>
      </svg>
    ),
    title: 'Touchscreen + CarPlay',
    description: 'Your playlist, your maps, your ADVENTURE.',
  },
  {
    id: 'free-delivery',
    iconBgColor: 'bg-red-100',
    iconColor: 'text-red-600',
    icon: (
      <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path>
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
      </svg>
    ),
    title: 'FREE Delivery & Pick-Up Anywhere',
    description: 'Resort, Airbnb, hotel… we roll RIGHT UP to you.',
  },
];